import React, { useEffect } from "react";
import ImgClassmate from "images/classmates.png";
import ImgTeacher from "images/tch.png";
import ImgBooks from "images/books.png";
import ImgComputer from "images/computer.png";
import ImgProhibited from "images/prohibited.jpg";


const AssessmentHelpRow = ({ selected, setSelected }) => {

    useEffect(() => {
        // console.log("AssessmentHelpRow called, selected", selected);
    }, []);

    const images = [
        { src: ImgClassmate, value: 10, alt: "Classmate", idx: 0 },
        { src: ImgTeacher, value: 20, alt: "Teacher", idx: 1 },
        { src: ImgBooks, value: 30, alt: "Books", idx: 2 },
        { src: ImgComputer, value: 40, alt: "Computer", idx: 3 },
        { src: ImgProhibited, value: 50, alt: "Self", idx: 4 },
    ];

    const handleSelect = (idx) => {
        setSelected((prevSelected) =>
            prevSelected.map((val, i) =>
                idx === 4 ?
                    (i === 4 ? !prevSelected[4] : false) :
                    (i === idx ? !val : (i === 4 ? false : val))
            )
        );
    };



    return (
        <div
            className="col-md-12 col-sm-12 col-xs-12 padding-remove"
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                margin: "10px 0",
                padding: "10px",
                backgroundColor: "#f9f9f9",
                borderRadius: "8px",
            }}
        >
            {images.map(({ src, value, alt, idx }) => (
                <div
                    key={value}
                    className="col-md-2 col-sm-2 col-xs-2 padding-remove"
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                        margin: "0 5px",
                    }}
                    onClick={() => handleSelect(idx)}
                >
                    <img
                        src={src}
                        alt={alt}
                        style={{
                            width: "35px",
                            height: "35px",
                            borderRadius: "5px",
                            border: selected[idx] ? "2px solid blue" : "1px solid #ddd",
                            padding: "3px",
                            backgroundColor: selected[idx] ? "#e6f7ff" : "transparent",
                        }}
                    />
                </div>
            ))}
        </div>
    );
};

export default AssessmentHelpRow;
